import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  login: "/auth/login",
  logout: "/auth/logout",
  token: "/auth/token",
  me: "/users/me",
  userLicenses: "/user",
  users: "/users",
  activateUser: "/users/activate",
  companies: "/organizations",
  projects: "/projects",
  licenses: "/licenses",
};

const endpointsSlice = createSlice({
  name: "endpoints",
  initialState,
  reducers: {},
});

export const {} = endpointsSlice.actions;
export default endpointsSlice.reducer;
